<template>
  <div>
    <b-field class="has-text-left">
      <b-checkbox class="group-price" v-model="item.conditionEngFail" :disabled="isBookedItem"
        >エンジン不調</b-checkbox
      >
      <b-checkbox class="group-price" v-model="item.priceSize18" @input="clickCheckbox18" :disabled="isBookedItem" >サイズ1,8 以上</b-checkbox>

      <b-checkbox class="group-price" v-model="item.priceSize23" @input="clickCheckbox23" :disabled="isBookedItem" >サイズ2,3 以上</b-checkbox>
    </b-field>
    <b-field v-if="item.conditionEngFail" label="エンジン不調:具体的な状況">
      <b-input
        type="textarea"
        placeholder="時々かかる、など"
        v-model="item.conditionEngFailLv"
        :disabled="isBookedItem"
      ></b-input>
    </b-field>
    <b-field class="has-text-left">
      <b-checkbox v-model="item.conditionRust" :disabled="isBookedItem"
        >サビ</b-checkbox
      >
    </b-field>
    <b-field v-if="item.conditionRust" label="サビ:具体的な状況">
      <b-input
        type="textarea"
        v-model="item.conditionRustLv"
        :disabled="isBookedItem"
      ></b-input>
    </b-field>
    <br />
    <div class="columns content statuscheckboxes">
      <div class="column is-one-quarter is-paddingless">
        <b-field class="has-text-left is-marginless">
          <b-checkbox v-model="item.conditionIsLowDown" :disabled="isBookedItem"
            >ローダウン</b-checkbox
          >
        </b-field>
        <b-field class="has-text-left is-marginless">
          <b-checkbox
            v-model="item.conditionIsPoorElec"
            :disabled="isBookedItem"
            >電格不良</b-checkbox
          >
        </b-field>
        <b-field class="has-text-left is-marginless">
          <b-checkbox
            v-model="item.conditionIsASISMovable"
            :disabled="isBookedItem"
            >現状車(可動)</b-checkbox
          >
        </b-field>
      </div>
      <div class="column is-one-quarter is-paddingless">
        <b-field class="has-text-left is-marginless">
          <b-checkbox v-model="item.conditionIsWithBox" :disabled="isBookedItem"
            >箱付</b-checkbox
          >
        </b-field>
        <b-field class="has-text-left is-marginless">
          <b-checkbox
            v-model="item.conditionIsDRVSidePWFail"
            :disabled="isBookedItem"
            >運転席PW不良</b-checkbox
          >
        </b-field>
        <b-field class="has-text-left is-marginless">
          <b-checkbox
            v-model="item.conditionIsASISImmovable"
            :disabled="isBookedItem"
            >現状車(不動)</b-checkbox
          >
        </b-field>
      </div>
      <div class="column is-one-quarter is-margineless is-paddingless">
        <b-field class="has-text-left is-marginless">
          <b-checkbox
            v-model="item.conditionIsFlatBody"
            :disabled="isBookedItem"
            >平ボディ</b-checkbox
          >
        </b-field>
        <b-field class="has-text-left is-marginless">
          <b-checkbox
            v-model="item.conditionIsImmovable"
            :disabled="isBookedItem"
            >不動車</b-checkbox
          >
        </b-field>
        <!-- START QuocNV 20231205 add condition -->
        <b-field class="has-text-left is-marginless">
          <b-checkbox
            v-model="item.conditionIsSelftpropelled"
            :disabled="isBookedItem"
            @input="checkBoxIsSelft"
            >自走陸送でも良い</b-checkbox
          >
        </b-field>
        <!-- END QuocNV 20231205 add condition -->
      </div>
      <div class="column is-one-quarter is-margineless is-paddingless">
        <b-field class="has-text-left is-marginless">
          <b-checkbox v-model="item.conditionIsOilLeak" :disabled="isBookedItem"
            >オイル漏れ</b-checkbox
          >
        </b-field>
        <b-field class="has-text-left is-marginless">
          <b-checkbox
            v-model="item.conditionISAccident"
            :disabled="isBookedItem"
            >事故車</b-checkbox
          >
        </b-field>
        <!-- START QuocNV 20231205 add condition -->
        <b-field class="has-text-left is-marginless">
          <b-checkbox
            v-model="item.conditionIsLoadedTransport"
            :disabled="isBookedItem"
            @input="checkBoxIsLoaded"
            >積載陸送のみ</b-checkbox
          >
        </b-field>
        <!-- END QuocNV 20231205 add condition -->
      </div>
    </div>
    <b-field label="その他:気になる所">
      <b-input
        type="textarea"
        placeholder="タイヤの溝など"
        v-model="item.conditionRemarks"
        :disabled="isBookedItem"
      ></b-input>
    </b-field>
    <br />
    <b-field class="has-text-center is-marginless">
      <b-checkbox v-model="item.conditionChecked" :disabled="isBookedItem"
        >状態チェック済み</b-checkbox
      >
    </b-field>
  </div>
</template>
<style scoped>
.statuscheckboxes {
  margin-left: 0px;
  padding-left: 0px;
}
.group-price{
  width: 33%;
}
</style>
<script>
export default {
  props: ['item', 'isBookedItem','transportVendors'],
  methods : {
    clickCheckbox18() {
      //check condition 
      if(!this.item.priceSize23 && this.item.transportVendorId && this.item.transportActualCost){
        //start feature add value checkbox 1.8 
        if(this.item.priceSize18){
          //get value new when checkbox
          this.item.transportActualCost = +this.item.transportActualCost * +this.transportVendors.filter((option)=>option.TransporterID.value == this.item.transportVendorId)[0].priceSize18.value;
        }else {
          //get value default when uncheckbox
          this.item.transportActualCost = +this.item.transportActualCost / +this.transportVendors.filter((option)=>option.TransporterID.value == this.item.transportVendorId)[0].priceSize18.value;
        }
        //end feature add value checkbox 1.8
      }
    },
    clickCheckbox23() {
      if(this.item.transportVendorId && this.item.transportActualCost){
        //start feature add value checkbox 2.3
        if(this.item.priceSize23){
          //check if checkbox 18 true then get value default of "transportActualCost"
          if(this.item.priceSize18){
            this.item.transportActualCost = +this.item.transportActualCost / +this.transportVendors.filter((option)=>option.TransporterID.value == this.item.transportVendorId)[0].priceSize18.value;
          }
          //get value from value default when checkbox 2.3 true
          this.item.transportActualCost = +this.item.transportActualCost * +this.transportVendors.filter((option)=>option.TransporterID.value == this.item.transportVendorId)[0].priceSize23.value;
        }else {
          //get value default when uncheckbox
          this.item.transportActualCost = +this.item.transportActualCost / +this.transportVendors.filter((option)=>option.TransporterID.value == this.item.transportVendorId)[0].priceSize23.value;
          //check value checkbox 1.8 if true
          if(this.item.priceSize18){
            //get value when checkbox 2.3 false and checkbox 1.8 true
            this.item.transportActualCost = +this.item.transportActualCost * +this.transportVendors.filter((option)=>option.TransporterID.value == this.item.transportVendorId)[0].priceSize18.value;
          }
        }
        //end feature add value checkbox 2.3
      }
    },
    checkBoxIsSelft(){
      if(this.item.conditionIsSelftpropelled){
        this.item.conditionIsLoadedTransport = false;
      }
    },
    checkBoxIsLoaded(){
      if(this.item.conditionIsLoadedTransport){
        this.item.conditionIsSelftpropelled = false;
      }
    }
  }
};
</script>
